import * as yup from 'yup';
import * as FORM_TYPES from '../constants/forms.constants';
import { VIEW_LAYOUTS } from '../plannerConfig';

// Fields
const DASHBOARD_FIELDS = {
  NAME: 'name',
  COLOUR: 'colour',
  IS_DEFAULT: 'isDefault',
  VIEW_LAYOUT: 'dashboardLayouts',
  CONTEXT_SPECIFIC: 'contextSpecific',
};

// Form Definition
const definition = context => [
  {
    label: 'Name',
    key: DASHBOARD_FIELDS.NAME,
    component: FORM_TYPES.INPUT,
    validation: yup.string().required('Dashboard name is required'),
  },
  {
    label: 'Colour',
    key: DASHBOARD_FIELDS.COLOUR,
    component: FORM_TYPES.COLOUR,
    validation: yup.string().matches(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i).required(),
  },
  {
    label: 'Default Tab',
    description: 'Should this tab be the default view when you log into the application?',
    key: DASHBOARD_FIELDS.IS_DEFAULT,
    component: FORM_TYPES.BOOLEAN,
    validation: yup.bool().required(),
  },
  {
    label: 'Context specific',
    description: 'Should this layout applied to both week and day? Enable this to keep them separate. This does not affect saving the filters.',
    key: DASHBOARD_FIELDS.CONTEXT_SPECIFIC,
    component: FORM_TYPES.BOOLEAN,
    validation: yup.bool(),
  },
  {
    label: `${context} View Layout`,
    key: DASHBOARD_FIELDS.VIEW_LAYOUT,
    component: FORM_TYPES.VIEW_LAYOUT,
    validation: yup.array().required(),
    lookupData: [VIEW_LAYOUTS, 'context'],
  },
];

// Validation
const schema = context => yup.object().shape({
  ...definition(context).reduce((acc, curr) => ({ ...acc, [curr.key]: curr.validation }), {}),
});

// Initial Form Values
const initialValues = {
  [DASHBOARD_FIELDS.NAME]: '',
  [DASHBOARD_FIELDS.COLOUR]: '',
  [DASHBOARD_FIELDS.IS_DEFAULT]: false,
  [DASHBOARD_FIELDS.CONTEXT_SPECIFIC]: false,
};

const DashboardForm = ({ context }) => (
  {
    definition: definition(context),
    initialValues,
    schema: schema(context),
  }
);

export default DashboardForm;
